import React, { useEffect, useState } from "react";
import { generatePath, useNavigate } from "react-router-dom";
import {
  addToEmployee,
  createDepartment,
  createEmployeee,
} from "../../firebase/firebase";
import toast from "react-hot-toast";
import EmployeeItems from "../employeeItems/employeeItems";
import "../../css/homepage.css";
import { doc, getFirestore, onSnapshot } from "firebase/firestore";
import Dropdown from "../tools/Dropdown";

const EmployeeMangement = ({ values }) => {
  const db = getFirestore();
  const [employees, setEmployees] = useState([]);
  const [data, setData] = useState([]);
  const [selectedItem, setSelectedItem] = useState("");
  const [newEmployee, setNewEmployee] = useState({
    address: "",
    payid: "",
    name: "",
    salary: 0,
    startdate: "",
    department: "",
    payday: 0,
  });

  // const [id, setId] = useState()
  const navigate = useNavigate();

  // proceed to payment details
  const handleProceed = (id, item) => {
    id &&
      navigate(generatePath("/dashboard/employee/:id", { id }), {
        state: {
          email: values?.email,
          address: item?.address,
          salary: item?.salary,
          name: item?.name,
          payId: item?.payid,
          department: item?.department,
          signerAddy: values?.email,
        },
      });
  };

  // handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setNewEmployee({
      ...newEmployee,
      [name]: value,
    });
  };

  const handleDropdownSelect = (selectedValue) => {
    setSelectedItem(selectedValue);
  };

  // detect firebase changes
  const watchFireBaseDataBase = () => {
    try {
      const tronweb = window.tronWeb;
      if (!tronweb) return;
      const { base58 } = tronweb.defaultAddress;
      const address = tronweb.address.toHex(base58);
      if (!address) return;
      const myCollection = doc(db, "users", address);
      const unsubscribe = onSnapshot(myCollection, (querySnapshot) => {
        const newData = querySnapshot.data();
        setData(newData?.department);
        setEmployees(newData?.employee); // Update the state with the retrieved data
      });
      return () => unsubscribe();
    } catch (error) {}
  };

  // create department
  const create_Department = () => {
    const notification = toast.loading("⏳ Creating department...");
    try {
      const tronweb = window.tronWeb;
      if (!tronweb) return;
      const { base58 } = tronweb.defaultAddress;
      const address = tronweb.address.toHex(base58);
      if (!address) return;
      createDepartment(newEmployee.department, address);
      toast.success("✅ Done", {
        id: notification,
      });
    } catch (error) {
      console.log(error);
    }
  };

  // useeffect
  useEffect(() => {
    watchFireBaseDataBase();
  }, []);

  // create employee function
  const createWallet = async () => {
    try {
      console.log(selectedItem);
      if (!selectedItem) return;
      const tronweb = window.tronWeb;
      const notification = toast.loading("⏳ Creating employee...");
      const contract = await tronweb
        .contract()
        .at(process.env.REACT_APP_companyAddress);
      const planid = await contract.nextPlanId().call();
      const plan = tronweb.toDecimal(planid);
      console.log(planid);
      const salary = tronweb.toSun(newEmployee.salary);
      const createEmploy = await contract
        .createEmployee(newEmployee.address, salary, newEmployee.payday)
        .send({
          feeLimit: 100_000_000,
          callValue: 0,
        });

      setTimeout(async () => {
        toast.loading("⏳ Setting up employee..", {
          id: notification,
        });
        const setUpEmployee = await contract.subscribe(planid).send({
          feeLimit: 100_000_000,
          callValue: salary,
        });
        toast.loading("⏳ Finishing...", {
          id: notification,
        });
        await createEmployeee(
          values?.email,
          newEmployee,
          plan,
          createEmploy,
          setUpEmployee,
          true,
          selectedItem
        );
        await addToEmployee(
          newEmployee.address,
          newEmployee,
          values?.businessLogoUrl,
          values?.companyName,
          plan,
          values?.email,
          selectedItem
        );
        toast.success("✅ Done", {
          id: notification,
        });
      }, 4000);
    } catch (error) {}
  };

  // handle submit
  const handleSubmit = async (e) => {
    e.preventDefault();
    createWallet();
  };

  return (
    <div className="lg:px-12 space-y-4 pb-8 py-4">
      <div>
        <p className="text-xl font-semibold py-2 title">Employee Management</p>
      </div>
      <div className="lg:grid grid-cols-5 lg:space-x-3 space-y-3 h-[100vh] mx-2">
        <div className="col-span-3 bg-[#434242] rounded-sm shadow-xl px-4 py-4">
          <div className="grid grid-cols-5 py-3 px-4 text-sm text-white">
            <p className="col-span-1">Name</p>
            <p className="col-span-1">Job title</p>
            <p className="col-span-1">Salary</p>
            <p className="col-span-1">Start date</p>
            <p className="col-span-1"></p>
          </div>
          <>
            {employees.map((item, i) => (
              <div key={i} onClick={() => handleProceed(item?.name, item)}>
                <EmployeeItems employee={item} />
              </div>
            ))}
          </>
        </div>
        <div className="col-span-2 bg-transparent grid grid-rows-5 h-[100vh]">
          <div className="row-span-4 bg-[#434242] shadow-xl border-[1px] py-4 space-y-4 rounded inputBox">
            <p className="text-center text-lg font-semibold text-white">
              Add an Employee
            </p>
            <div className="px-7">
              <form
                onSubmit={handleSubmit}
                className="space-y-2 bg-[#434242] rounded-sm py-4 px-2"
              >
                <div>
                  <label className="text-[13px] font-normal py-2 leading-4 text-white">
                    Employee Full Name
                  </label>
                  <input
                    id="name"
                    type="text"
                    className="py-2 w-full p-2 text-[13px] bg-white/60"
                    name="name"
                    placeholder="Full Name"
                    value={newEmployee.name}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div>
                  <label className="text-[13px] font-normal py-2 leading-4 text-white">
                    Department
                  </label>
                  <Dropdown items={data} onSelect={handleDropdownSelect} />
                </div>
                <div>
                  <label className="text-[13px] font-normal py-2 leading-4 text-white">
                    Start Date
                  </label>
                  <input
                    id="startdate"
                    type="date"
                    className="py-2 w-full p-2 text-[13px] bg-white/60"
                    name="startdate"
                    placeholder="Date"
                    value={newEmployee.startdate}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div>
                  <label className="text-[13px] font-normal py-2 leading-4 text-white">
                    Next Pay
                  </label>
                  <input
                    id="payDay"
                    type="text"
                    className="py-2 w-full p-2 text-[13px] bg-white/60"
                    name="payday"
                    placeholder="Next Pay in days"
                    onChange={(e) =>
                      setNewEmployee({
                        ...newEmployee,
                        payday: e.target.value * 86400,
                      })
                    }
                    required
                  />
                </div>
                <div>
                  <label className="text-[13px] font-normal py-2 leading-4 text-white">
                    Address
                  </label>
                  <input
                    id="address"
                    type="text"
                    className="py-2 w-full p-2 text-[13px] bg-white/60"
                    name="address"
                    placeholder="Employee Address"
                    value={newEmployee.address}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div>
                  <label className="text-[13px] font-normal py-2 leading-4 text-white">
                    Salary
                  </label>
                  <input
                    id="salary"
                    type="text"
                    className="py-2 w-full p-2 text-[13px] bg-white/60"
                    name="salary"
                    placeholder="Salary"
                    value={newEmployee.salary}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="flex items-center justify-center">
                  <button
                    type="submit"
                    className="px-6 py-2 bg-[#22f4fa]/60 shadow-xl text-[13px] my-2 rounded-sm"
                  >
                    Add Employee
                  </button>
                </div>
              </form>
            </div>
          </div>
          <div className="row-span-1 bg-[#434242] rounded mt-5 text-white flex flex-col items-center inputBox">
            <p className="font-semibold text-center p-2">Create Department</p>
            <input
              type="text"
              className="py-2 w-[80%] p-2 text-[13px] bg-white/60"
              name="department"
              value={newEmployee.department}
              placeholder="Enter name of department"
              onChange={handleChange}
              required
            />
            <button
              onClick={create_Department}
              className="px-6 py-1 bg-[#22f4fa]/60 shadow-xl text-[13px] my-2 rounded-sm"
            >
              Create
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmployeeMangement;
